import React, { useState } from 'react'
import {
  Button, Popover, List, ListItem, ListItemButton, ListItemText,
} from '@mui/material'
import AddIcon from '@mui/icons-material/Add'

export const predefinedVariables = [
  {
    name: 'customer_name',
    description: 'Customer name as they registered on Sokolink',
    example: 'John Doe',
  },
  {
    name: 'order_no',
    description: 'Order serial number generated per order',
    example: 'SKO1234567',
  },
  {
    name: 'service_type',
    description: 'The order service type either delivery, pickup, takeaway or dinein',
    example: 'delivery',
  },
  {
    name: 'store_name',
    description: 'Your brand name as set on Sokolink',
    example: 'Mama Dishes',
  },
  {
    name: 'store_phone',
    description: 'The main store contact phone number',
    example: '+254702029444',
  },
  {
    name: 'rider_details',
    description: 'Rider name and phone number',
    example: 'John Doe - +254702029444',
  },
  {
    name: 'cancel_reason',
    description: 'Reason as to why an order is rejected',
    example: 'Item Unvailability',
  },
]

const PredefinedVariableButton = ({ handleAddPredefinedVariable }) => {
  const [anchorEl, setAnchorEl] = useState(null)

  const handleButtonClick = (event) => {
    setAnchorEl(event.currentTarget)
  }

  const handleClose = () => {
    setAnchorEl(null)
  }

  const open = Boolean(anchorEl)
  const id = open ? 'predefined-variable-popover' : undefined

  return (
    <div>
      <Button
        size="small"
        startIcon={<AddIcon />}
        sx={{ textTransform: 'capitalize' }}
        onClick={handleButtonClick}
      >
        Sokolink Variable
      </Button>
      <Popover
        id={id}
        open={open}
        anchorEl={anchorEl}
        onClose={handleClose}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'center',
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'center',
        }}
      >
        <List>
          {predefinedVariables.map((variable) => (
            <ListItem key={variable} disablePadding>
              <ListItemButton
                onClick={() => {
                  handleAddPredefinedVariable(variable)
                  handleClose()
                }}
              >
                <ListItemText primary={variable.name} />
              </ListItemButton>
            </ListItem>
          ))}
        </List>
      </Popover>
    </div>
  )
}

export default PredefinedVariableButton
